import { render, staticRenderFns } from "./DashboardRelancesFormation.vue?vue&type=template&id=1bf49600&"
import script from "./DashboardRelancesFormation.vue?vue&type=script&lang=js&"
export * from "./DashboardRelancesFormation.vue?vue&type=script&lang=js&"
import style0 from "./DashboardRelancesFormation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports